/*
 * Date: 2023
 * Description: Help page
 * Author: Philippe Leroux @ skitsc
 */

import { Box } from "@mui/material"
import { ReactElement } from "react"

//Interfaces && types
import { i_initial_props } from "../interfaces/utility.interface"

const Help = ( props : i_initial_props ) : ReactElement => {
    return (
        <Box>

        </Box>
    )
}


export default Help